import { LIST_NOTIFICATIONS, UNREAD_NOTIFICATION_COUNT } from '@/constants/api'
import type {
	InfiniteData,
	UseQueryOptions,
	UseSuspenseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { get, post } from '../request'

export const UNREAD_NOTIFICATION_COUNT_QUERY_OPTIONS: UseQueryOptions<number> = {
	queryKey: [UNREAD_NOTIFICATION_COUNT],
	queryFn: () => get(UNREAD_NOTIFICATION_COUNT).then((res) => res.data.unreadCount),
	initialData: 0,
	placeholderData: 0,
}

interface QueryNotificationsPage {
	data: Notification[]
	loadMoreKey?: unknown
}
export const NOTIFICATIONS_QUERY_OPTIONS: UseSuspenseInfiniteQueryOptions<
	QueryNotificationsPage,
	unknown,
	InfiniteData<QueryNotificationsPage>
> = {
	queryKey: [LIST_NOTIFICATIONS],
	queryFn: ({ pageParam }) =>
		post<QueryNotificationsPage>(LIST_NOTIFICATIONS, {
			limit: 20,
			loadMoreKey: pageParam,
		}).then((res) => {
			const body = res.data

			return body
		}),
	getNextPageParam: (lastPage: QueryNotificationsPage) => lastPage.loadMoreKey,
	initialPageParam: undefined,
	initialData: {
		pages: [],
		pageParams: [],
	},
	refetchOnMount: false,
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
	retryOnMount: false,
}
